export default __webpack_public_path__ + "static/media/logostix.d5349ac3.png";